<section class="scarica-app">
  <a href="https://play.google.com/store/apps/details?id=it.myvet" target="_blank">
    <img src="/home-page/icons/footer/google-play.svg" loading="lazy" alt="Google play">
  </a>

  <a href="https://apps.apple.com/it/app/myvet/id6463804287" target="_blank">
    <img src="/home-page/icons/footer/app-store.svg" loading="lazy" alt="App store">
  </a>
</section>
